export default "__VITE_ASSET__MpoBUWVx__"